import { webClient } from "@shared/apis"

export default {
  status: () => webClient.get<StudioPermissions>(`/studio_permissions/status`),
  findBy: (userId: number) =>
    webClient.get<StudioPermissions>(`/studio_permissions/${userId}`),
}

export interface StudioPermissions {
  id: number
  userId: number
  username: string
  isAllowedBlockChat: boolean
  isAllowedKick: boolean
}
